<style>
@media print {
  body {
    zoom: 80%; /* shrink if content is too large */
  }

  .print-container {
    page-break-inside: avoid !important;
    page-break-before: avoid !important;
    page-break-after: avoid !important;
    overflow: hidden !important;
  }

  @page {
    size: A4;        /* or letter */
    margin: 5mm;    /* adjust margins */
  }
}
</style>

<template>
  <div class="white justify-center print-container">
    <v-row class="justify-center d-print-none" no-gutters>
      <v-col class="d-flex justify-end" cols="10">
        <v-btn color="success" @click="print()">{{ $t("PRINT") }}</v-btn>
        <v-btn
            class="mx-2"
            color="error"
            @click="
            $router.push({
              name: 'ManageApplicationsList'
            })
          "
        >
          {{ $t("BACK") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="justify-center" no-gutters>
      <v-avatar v-show="$vuetify.breakpoint.mdAndUp" size="70">
        <img :src="logo"/>
      </v-avatar>
      <v-col class="d-flex flex-column justify-center" cols="10">
        <h3>{{ serverTranslate(universityName) }}</h3>
        <h3>{{ serverTranslate(applicationFaculty) }} </h3>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col class="text-center py-2" cols="12">
        <h3>
          {{
            $t("APPLICATION_TITLE", {
              appYear,
              appSemeter: serverTranslate(appSemeter)
            })
          }}
        </h3>
      </v-col>
      <v-col class="d-inline-block my-1 py-2 border-radius-5" cols="10">
        <h3 class="my-0 text-center">{{ $t("UserData.PERSONAL_DATA") }}</h3>
        <v-row no-gutters>
          <v-col cols="6" lg="6" md="6" sm="6">
            <v-row no-gutters>
              <v-col class="py-0" cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.AR_NAME") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ arName }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.EN_NAME") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ enName }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.NATIONALITY") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ serverTranslate(nationality) }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong>
                    {{
                      cardType === 1
                          ? $t("UserData.NATIONAL_ID")
                          : $t("UserData.PASSPORT")
                    }}:
                  </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ cardID }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.GENDER") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{
                    gender === 13 ? $t("UserData.MALE") : $t("UserData.FEMALE")
                  }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.BIRTHDAY") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ birthdate }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-inline-block my-1 py-2 border-radius-5" cols="10">
        <h3 class="mt-0 text-center">{{ $t("UserData.CONTACT") }}</h3>

        <v-row no-gutters>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.PHONE") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  <bdi>{{ telephone }}</bdi>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.MOBILE") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  <bdi>{{ mobile }}</bdi>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.ADDRESS") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ address }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.EMAIL") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ email }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-inline-block my-1 py-2 border-radius-5" cols="10">
        <h3 class="mt-0 text-center">{{ $t("UserData.CERTIFICATE") }}</h3>

        <v-row no-gutters>
          <v-col class="py-0" cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.CERTIFICATE_TYPE") }}: </strong>
                </v-card>
              </v-col>
              <v-col class="py-0" cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ serverTranslate(certificateTypes) }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0" cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.CERTIFICATE_DEPT") }}: </strong>
                </v-card>
              </v-col>
              <v-col class="py-0" cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ serverTranslate(divisionType) }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col
              v-if="!!equationCertificateTypes"
              class="py-0" cols="6" lg="6" md="6" sm="6"
              xl="6"
          >
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.CERTIFICATE_EQ_TYPE") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ serverTranslate(equationCertificateTypes) }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col
              v-if="!!foreignCertificate && !isAnotherForeignCertificate"
              class="py-0" cols="6" lg="6" md="6" sm="6"
              xl="6"
          >
            <v-row no-gutters>
              <v-col class="py-0" cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong>
                    {{ $t("UserData.CERTIFICATE_FOREIGN_TYPE") }}:
                  </strong>
                </v-card>
              </v-col>
              <v-col class="py-0" cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ serverTranslate(foreignCertificate) }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col
              v-if="!!otherCertificateText" class="py-0" cols="6" lg="6" md="6"
              sm="6"
              xl="6"
          >
            <v-row no-gutters>
              <v-col class="py-0" cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.CERTIFICATE_OTHER") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ otherCertificateText }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0" cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.CERTIFICATE_YEAR") }}: </strong>
                </v-card>
              </v-col>
              <v-col class="py-0" cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ preQualYear }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0" cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.CERTIFICATE_RESULT") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ preQualTotal }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0 " cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.COUNTRY") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ serverTranslate(preQualCountry) }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-inline-block my-1 py-2 border-radius-5" cols="10">
        <h3 class="my-0 text-center">{{ $t("APP_DATA") }}</h3>
        <v-row no-gutters>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col class="py-0" cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("APPID") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ $route.params.id }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("APPLICATION_CASES") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ (applicationIdus ? getAppStatusText(applicationIdus) : '') }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>


        <v-row no-gutters>
          <v-col cols="6" lg="6" md="6" sm="6" xl="6">
            <v-row no-gutters>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("PAYMENT_STATUS") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ getPaymentStatusText }}
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card class="pa-1 elevation-0">
                  <strong> {{ $t("UserData.FACULTY") }}: </strong>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="pa-1 elevation-0">
                  {{ serverTranslate(applicationFaculty) }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>

        </v-row>

      </v-col>

      <v-col class="d-inline-block my-1 py-2 border-radius-5" cols="10">
        <h3 class="my-0 text-center">{{ $t("DESIRES_DATA") }}</h3>

        <v-simple-table class="elevation-1 rounded">
          <thead>
          <tr>
            <th class=" text-black font-weight-bold border">#</th>
            <th class="text-black font-weight-bold border">{{ $t("UserData.FACULTY") }}</th>
            <th class="text-black  font-weight-bold border">{{ $t("UserData.APPLICATION_ID") }}</th>
            <th class=" text-black  font-weight-bold border">{{ $t("UserData.APPLICATION_STATUS") }}</th>
            <th class="text-black  font-weight-bold border">{{ $t("UserData.DESIRE_NUMBER") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(application, index) in applicationList"
              :key="index"
              :class="index % 2 === 0 ? 'bg-grey-lighten-4' : ''"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ serverTranslate(application.facultyName) }}</td>
            <td>{{ application.applicationId }}</td>
            <td>{{ serverTranslate(application.applicationStatus) }}</td>
            <td>{{ application.desireNumber }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row class="justify-center" no-gutters>
      <v-col class="pb-0 mt-5" cols="10">
        <h3>أقر أنا </h3>
        <p class="mb-0">المرشح للقبول بالجامعة بان كافة البيانات المدونة بمعرفتي صحيحة وعلى
          مسؤوليتي الكاملة وانه في حالة ظهور واكتشاف بان تلك البيانات غير صحيحة يعد الطلب مرفوض لعدم استيفاء الشروط
          وتنازل منى عن التقدم وان جميع هذه الاوراق والمستندات تحت المراجعة بمعرفة المجلس الاعلى للجامعات الاهلية
          بالقاهرة.
          كما اننى اتعهد بتقديم اصول المستندات لاستكمال اجراءات القيد عقب اعلان نتيجة التنسيق في موعد اقصاه 48 ساعه مع
          الالتزام بسداد الرسوم والمصروفات الدراسية وفى حالة عدم الالتزام يحق للجامعة رفض طلب الالتحاق .</p>
      </v-col>
    </v-row>
    <v-row class="justify-center" no-gutters>
      <v-col class="pb-0 mt-2" cols="10"><h4>{{ $t('STUDENT_SIGNATURE') }} </h4></v-col>
    </v-row>
  </div>

</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.ts";
import globalMethods from "@/mixins/globalMethods";

export default {
  mixins: [serverTranslationsMixin, globalMethods],
  created() {
    this.logo = localStorage.getItem("logo");
    this.getApplicationData();
  },
  computed: {
    IsArabic() {
      return localStorage.lang === "ar";
    },
    address() {
      const Country = this.serverTranslate(this.addressCountry);
      const State = this.serverTranslate(this.addressState);
      const City = this.serverTranslate(this.addressCity);
      return `${Country} / ${State} / ${City}`;
    },
    // getAppStatusText() {
    //   return (this.applicationIdus ? getAppStatusText(this.applicationIdus) : '')
    // },
    getPaymentStatusText() {
      /* eslint-disable no-debugger */
      return (this.payment.status === 1 ? this.$t("PAID") : this.$t('NOT_PAID'))
    }
  },
  data() {
    return {
      logo: '',
      isAnotherForeignCertificate: false,
      dialog: false,
      applicationIdus: '',
      paymentStatus: '',
      payment: '',
      arName: "",
      enName: "",
      profilePicture: null,
      universityName: "",
      applicationFaculty: "",
      appSemeter: "",
      appYear: "",
      nationality: "",
      gender: "",
      telephone: "",
      birthdate: "",
      mobile: "",
      cardID: "",
      cardType: "",
      email: "",
      addressCountry: "",
      addressState: "",
      addressCity: "",
      preQualCountry: "",
      preQualYear: "",
      certificateTypes: "",
      equationCertificateTypes: "",
      divisionType: "",
      foreignCertificate: "",
      otherCertificateText: "",
      preQualTotal: "",
      branch: "",
      applicationList: [],
    };
  },
  methods: {
    print() {
window.print();
},
    getApplicationData() {
      const applicationId = this.$route.params.id;
      return this.$http
          .post("/api/students_admission_apps/application_details/", {
            applyId: applicationId
          })
          .then(response => {
            const responseData = response.data.data.application_details;
                        this.applicationIdus=responseData.applicationIdus
            this.applicationList = response.data.data.applicationsData;
            this.mapApplicationData(responseData);
          });
    },
    mapApplicationData(data) {
      Object.keys(data).forEach(key => {
        this.$data[key] = data[key] || "";
      });

      this.isAnotherForeignCertificate = this.foreignCertificate.id
          ? this.foreignCertificate.id === 32
          : false;

      this.applicationFaculty = this.applicationFaculty.name || "";
      this.appSemeter = this.appSemeter.name || "";
      this.appYear = this.appYear.name
          ? this.appYear.name.replace("|", " - ")
          : "";
      this.nationality = this.nationality.name || "";

      const gender = parseInt(this.gender.id);
      this.gender = parseInt(this.gender.id) ? ([13, 14].includes(gender) ? gender : 13) : 13;

      const cardType = parseInt(this.cardType.id);
      this.cardType = cardType ? ([1, 2].includes(cardType) ? cardType : 1) : 1;

      this.addressCountry = this.addressCountry.name || "";
      this.addressState = this.addressState.name || "";
      this.addressCity = this.addressCity.name || "";
      this.preQualCountry = this.preQualCountry.name || "";
      this.preQualYear = this.preQualYear.name
          ? this.preQualYear.name.replace("|", " - ")
          : "";
      this.certificateTypes = this.certificateTypes.name || "";
      this.equationCertificateTypes = this.equationCertificateTypes.name || "";
      this.divisionType = this.divisionType.name || "";
      this.foreignCertificate = this.foreignCertificate.name || "";
      this.branch = this.branch.name || "";
    }
  }
};
</script>
<style>
@media print {
  .v-content {
    padding: 0 !important;
  }
}
</style>
